import { render } from "./EditFluxo.vue?vue&type=template&id=67b06c22"
import script from "./EditFluxo.vue?vue&type=script&lang=js"
export * from "./EditFluxo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__